import React, { useEffect, useState } from 'react'
import Navbar from '../Comman_Layout/Header/Navbar'
import { Link, useNavigate } from 'react-router-dom'
import Footer from '../Comman_Layout/Footer/Footer'
import { useFormik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import Swal from 'sweetalert2';
import $ from "jquery";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Step, Stepper } from 'react-form-stepper';
// import {Stepper} from 'react-stepper-horizontal'

const ITServiceProviderCompanyDetails = () => {
    const navigate = useNavigate();

    let [initialValues, setInitialValues] = useState({
        id: "",
        name_of_organisation: "",
        address: "",
        city: "",
        state: "",
        country: "",
        pin_code: "",
        website: "",
        contact_no: "",
        year_of_commencement: "",
        year_of_commencement_text: "",
        gst_no: "",
        gst_no_text: "",
        gst_no_uploaded: localStorage.getItem("company_details") ? JSON.parse(localStorage.getItem("company_details")).gst_no : "",
        gst_no_new: "",
        pan_no: "",
        pan_no_uploaded: localStorage.getItem("company_details") ? JSON.parse(localStorage.getItem("company_details")).pan_no : "",
        pan_no_new: "",
        pan_no_text: "",
        no_of_manpower: "",
        type_of_organisation: "",
        last_year_turnover: "",
        five_major_clients: "",
        company_main_services: "",
        name_of_proprietor: "",
        proprietor_designation: "",
        proprietor_mobile_no: "",
        proprietor_email: "",
    })
    let [showNewGSTdiv, setShowNewGSTdiv] = useState(false)
    let [showNewPANdiv, setShowNewPANdiv] = useState(false)
    let [showNewYOCdiv, setShowNewYOCdiv] = useState(false)
    let [showNewCMSdiv, setShowNewCMSdiv] = useState(false)
    let [showNewFMCdiv, setShowNewFMCdiv] = useState(false)
    let handleGSTfilediv = () => {
        setShowNewGSTdiv(true)
    }
    let handlePANfilediv = () => {
        setShowNewPANdiv(true)
    }
    let handleYOCfilediv = () => {
        setShowNewYOCdiv(true)
    }
    let handleCMSfilediv = () => {
        setShowNewCMSdiv(true)
    }
    let handleFMCfilediv = () => {
        setShowNewFMCdiv(true)
    }
    useEffect(() => {
        $(".remove-disabled").removeAttr("disabled");
        // window.onload = window.localStorage.clear();
        if (localStorage.getItem('company_details')) {
            // console.log("In usestate.")
            let companyDetailsData = JSON.parse(localStorage.getItem("company_details"));
            console.log("companyDetailsData from localStorage::", companyDetailsData);
            setInitialValues({
                id: companyDetailsData.id,
                name_of_organisation: companyDetailsData.name_of_organisation,
                address: companyDetailsData.address,
                city: companyDetailsData.city,
                state: companyDetailsData.state,
                country: companyDetailsData.country,
                pin_code: companyDetailsData.pin_code,
                website: companyDetailsData.website,
                contact_no: companyDetailsData.contact_no,

                year_of_commencement: companyDetailsData.year_of_commencement,
                year_of_commencement_new: companyDetailsData.year_of_commencement_new,
                year_of_commencement_uploaded: companyDetailsData.year_of_commencement,
                year_of_commencement_text: companyDetailsData.year_of_commencement_text,

                gst_no: companyDetailsData.gst_no,
                gst_no_new: companyDetailsData.gst_no_new,
                gst_no_uploaded: companyDetailsData.gst_no,
                gst_no_text: companyDetailsData.gst_no_text,

                pan_no: companyDetailsData.pan_no,
                pan_no_new: companyDetailsData.pan_no_new,
                pan_no_uploaded: companyDetailsData.pan_no,
                pan_no_text: companyDetailsData.pan_no_text,

                no_of_manpower: companyDetailsData.no_of_manpower,
                type_of_organisation: companyDetailsData.type_of_organisation,
                last_year_turnover: companyDetailsData.last_year_turnover,
                last_year_turnover_text: companyDetailsData.last_year_turnover_text,

                five_major_clients: companyDetailsData.five_major_clients,
                five_major_clients_new: companyDetailsData.five_major_clients_new,
                five_major_clients_uploaded: companyDetailsData.five_major_clients,
                five_major_clients_text: companyDetailsData.five_major_clients_text,

                company_main_services: companyDetailsData.company_main_services,
                company_main_services_new: companyDetailsData.company_main_services_new,
                company_main_services_uploaded: companyDetailsData.company_main_services,

                name_of_proprietor: companyDetailsData.name_of_proprietor,
                proprietor_designation: companyDetailsData.proprietor_designation,
                proprietor_mobile_no: companyDetailsData.proprietor_mobile_no,
                proprietor_email: companyDetailsData.proprietor_email,
            })
        }

    }, []);

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: Yup.object({
            name_of_organisation: Yup.string()
                .min(2, 'Must be 2 characters or more')
                .max(30, 'Must be 30 characters or less')
                // .matches(/^[a-zA-Z _)]+$/, "Name should contain only Alphabets")
                .required('Name is required'),
            contact_no: Yup.string()
                .required("Contact No. is required.")
                .matches(/^[0-9]+$/, "Must contain digits only.")
                .min(8, 'Must be minimum 8 digits')
                .max(15, 'Must be maximum 15 digits'),

            proprietor_email: Yup.string().matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, "Enter a valid E-mail"),
            // .required('Email is required'),
            proprietor_mobile_no: Yup.string()
                .matches(/^[0-9]+$/, "Must contain digits only.")
                .min(8, 'Must be minimum 8 digits')
                .max(15, 'Must be maximum 15 digits'),
        }),

        onSubmit: (values, { resetForm }) => {

            let timerInterval;

            Swal.fire({
                title: 'Please Wait...',
                html: 'Your query is being submitted.',
                timer: 30000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading()
                    // const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                        //   b.textContent = Swal.getTimerLeft()
                    }, 100)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                }

            })
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
            // console.log("gst_no:::", values.gst_no.length)
            // console.log("values:", values)
            // console.log("gst_no", values.gst_no)
            // console.log("gst_no_new", values.gst_no_new)
            const formData = new FormData();
            formData.append("id", values.id)
            formData.append("name_of_organisation", values.name_of_organisation)
            formData.append("address", values.address)
            formData.append("city", values.city)
            formData.append("state", values.state)
            formData.append("country", values.country)
            formData.append("pin_code", values.pin_code)
            formData.append("website", values.website)
            formData.append("contact_no", values.contact_no);
            formData.append("year_of_commencement_updated", values.year_of_commencement_updated);
            // formData.append("year_of_commencement", values.year_of_commencement);
            formData.append("year_of_commencement",
                (!localStorage.getItem("company_details")) ?
                    values.year_of_commencement
                    :
                    (showNewYOCdiv ?
                        values.year_of_commencement_new
                        : (values.year_of_commencement_uploaded ?
                            values.year_of_commencement_uploaded
                            : values.year_of_commencement)
                    )

            )
            // formData.append("gst_no", showNewGSTdiv ? values.gst_no_uploaded ? values.gst_no_uploaded : values.gst_no : values.gst_no_new);
            formData.append("gst_no",
                (!localStorage.getItem("company_details")) ?
                    values.gst_no
                    :
                    (showNewGSTdiv ?
                        values.gst_no_new
                        : (values.gst_no_uploaded ?
                            values.gst_no_uploaded
                            : values.gst_no)
                    )

            )
            // formData.append("gst_no", values.gst_no);
            // formData.append("gst_no_new", values.gst_no_new);
            formData.append("pan_no",
                (!localStorage.getItem("company_details")) ?
                    values.pan_no
                    :
                    (showNewPANdiv ?
                        values.pan_no_new
                        : (values.pan_no_uploaded ?
                            values.pan_no_uploaded
                            : values.pan_no))

            )
            // formData.append("pan_no", values.pan_no);
            formData.append("no_of_manpower", values.no_of_manpower);
            formData.append("type_of_organisation", values.type_of_organisation);
            formData.append("last_year_turnover", values.last_year_turnover);
            formData.append("five_major_clients", values.five_major_clients);


            // formData.append("company_main_services", values.company_main_services);
            formData.append("company_main_services",
                (!localStorage.getItem("company_details")) ?
                    values.company_main_services
                    :
                    (showNewCMSdiv ?
                        values.company_main_services_new
                        : (values.company_main_services_uploaded ?
                            values.company_main_services_uploaded
                            : values.company_main_services))

            )

            formData.append("name_of_proprietor", values.name_of_proprietor);
            formData.append("proprietor_designation", values.proprietor_designation);
            formData.append("proprietor_mobile_no", values.proprietor_mobile_no);
            formData.append("proprietor_email", values.proprietor_email);
            formData.append("year_of_commencement_text", values.year_of_commencement_text);
            formData.append("gst_no_text", values.gst_no_text);
            formData.append("pan_no_text", values.pan_no_text);
            formData.append("last_year_turnover_text", values.last_year_turnover_text);
            formData.append("five_major_clients_text", values.five_major_clients_text);

            // console.log("GST NO.::::", values.gst_no);
            console.log("formData", formData.get("gst_no"))

            if (localStorage.getItem("company_details")) {
                let id = JSON.parse(localStorage.getItem("company_details")).id;
                // console.log("idddd::::", id);
                // axios.post(`http://localhost:1995/update-it-sevice-provider-company?id=${id}`, formData, config)
                axios.post(`https://tapi.alobhatech.com/update-it-sevice-provider-company?id=${id}`, formData, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            // console.log('removing localStrogae')
                            localStorage.removeItem("company_details");
                            let company_details = response.data.data;
                            console.log("response in update function::::", company_details);
                            localStorage.setItem("company_details", JSON.stringify(company_details));
                            Swal.fire(
                                'Congratulations.',
                                'Details updated.',
                                'success'
                            )
                            navigate("/it-service-provider-company-contact-person-details");

                        } else if (response.status == 201) {
                            Swal.fire(
                                'Warning',
                                'This email already exists.',
                                'warning'
                            )
                        } else if (response.status == 202) {
                            Swal.fire(
                                'Warning',
                                'This Mobile No. already exists.',
                                'warning'
                            )

                        } else {
                            Swal.fire(
                                'Please try again.',
                                'Something went wrong',
                                'error'
                            )
                            // $('#exampleModal').modal('hide');

                        }
                    })
                    .catch(function (error) {
                        console.log(`Error:`, error.response)
                        Swal.fire(
                            'Server Error, Please try again later.',
                            'Internal Server Error',
                            'error'
                        )
                        // $('#exampleModal').modal('hide');

                    })

            } else {
                // axios.post('http://localhost:1995/add-it-sevice-provider-company-details', formData, config)
                axios.post('https://tapi.alobhatech.com/add-it-sevice-provider-company-details', formData, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            let company_details = response.data.data;
                            console.log(`in add function.`);
                            // console.log("response::::", company_details);
                            localStorage.setItem("company_details", JSON.stringify(company_details));
                            Swal.fire(
                                'Congratulations.',
                                'Details Saved.',
                                'success'
                            )
                            // resetForm();
                            navigate("/it-service-provider-company-contact-person-details");

                        } else if (response.status == 201) {
                            // console.log(`Success!`)
                            Swal.fire(
                                'Warning',
                                'This email already exists.',
                                'warning'
                            )
                            // resetForm();
                            // $('#exampleModal').modal('hide');

                        } else if (response.status == 202) {
                            // console.log(`Success!`)
                            Swal.fire(
                                'Warning',
                                'This Mobile No. already exists.',
                                'warning'
                            )
                            // resetForm();
                            // $('#exampleModal').modal('hide');

                        } else {
                            Swal.fire(
                                'Please try again.',
                                'Something went wrong',
                                'error'
                            )
                            $('#exampleModal').modal('hide');

                        }
                    })
                    .catch(function (error) {
                        console.log(`Error:`, error.response)
                        Swal.fire(
                            'Server Error, Please try again later.',
                            'Internal Server Error',
                            'error'
                        )
                    })
            }

        }
    });


    return (
        <>
            <Navbar />

            <section className="service-provider my-5">
                <div className="container">
                    {/* =============Heading================== */}
                    <div className="empanelment-service">
                        <h1>Empanelment For IT Services Provider</h1>
                    </div>
                    {/* ===============Tab Area Start=============== */}
                    <div className="form-tab-area">
                        <ul className="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="pills-home-tab" data-toggle="pill" role="tab" aria-controls="pills-home" aria-selected="true">Company</a>
                            </li>
                            <Link to='/it-service-provider-individual-basic-details'>
                                <li className="nav-item actv-li">
                                    <a className="nav-link" id="pills-profile-tab" data-toggle="pill" role="tab" aria-controls="pills-profile" aria-selected="false">Individual</a>
                                </li>
                            </Link>
                        </ul>

                        <div className="stepper-step mt-5">
                            <ul class="form-stepper form-stepper-horizontal text-center mx-auto pl-0">

                                <li class="form-stepper-active text-center form-stepper-list" step="1">
                                    <Link class="mx-2">
                                        <span class="form-stepper-circle">
                                            <span>1</span>
                                        </span>
                                        <div class="label">Company Details</div>
                                    </Link>
                                </li>
                                <li class="form-stepper-unfinished text-center form-stepper-list" step="2">
                                    <Link class="mx-2" to="/it-service-provider-company-contact-person-details">
                                        <span class="form-stepper-circle text-muted">
                                            <span>2</span>
                                        </span>
                                        <div class="label text-muted">Contact Person Details</div>
                                    </Link>
                                </li>
                                <li class="form-stepper-unfinished text-center form-stepper-list" step="3">
                                    <Link class="mx-2" to='/it-service-provider-company-bank-details'>
                                        <span class="form-stepper-circle text-muted">
                                            <span>3</span>
                                        </span>
                                        <div class="label text-muted">Bank Details</div>
                                    </Link>
                                </li>
                                <li class="form-stepper-unfinished text-center form-stepper-list" step="3">
                                    <Link class="mx-2" to="/it-service-provider-company-service-offered">
                                        <span class="form-stepper-circle text-muted">
                                            <span>4</span>
                                        </span>
                                        <div class="label text-muted">Service Details</div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="tab-content" id="pills-tabContent">
                            {/* ===============Company Tab Area Start=============== */}
                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                <div className="custm-form">
                                    <form id='multistepsform' onSubmit={formik.handleSubmit}
                                        method="POST"
                                        encType="multipart/form-data"
                                    >
                                        {/* -----------Company Details------------ */}
                                        <fieldset style={{ position: "static" }}>
                                            <div className="title mb-4">
                                                <h4>Company Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <input type="hidden" name='id' id='id' value={localStorage.getItem("companyDetailsData") ? JSON.parse(localStorage.getItem("companyDetailsData")).id : ""} />
                                                    <label htmlFor="">Name of the Organization<span style={{ color: "red" }}>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Organization' id="name_of_organisation" name='name_of_organisation'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.name_of_organisation}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.name_of_organisation && formik.errors.name_of_organisation ? (
                                                            <div className='text-danger'>*{formik.errors.name_of_organisation}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Address <span></span></label>
                                                    <input type="text" className='form-control' placeholder='Address ' id='address' name='address'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.address} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">City<span></span></label>
                                                    <input type="text" className='form-control' placeholder='City' id='city' name='city'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.city} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">State<span></span></label>
                                                    <input type="text" className='form-control' placeholder='State' id='state' name='state'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.state} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Country<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Country' id='country' name='country'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.country} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Pin / Zip Code<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Pin / Zip Code' id='pin_code' name='pin_code'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.pin_code} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Website<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Website' id='website' name='website'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.website} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Contact Number<span style={{ color: "red" }}>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Contact Number' id='contact_no' name='contact_no'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.contact_no} />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.contact_no && formik.errors.contact_no ? (
                                                            <div className='text-danger'>*{formik.errors.contact_no}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="year_of_commencement_text">Year of Commencement of Business<span style={{ color: "green", fontWeight: "100", fontSize: "13px" }}></span></label>
                                                    <input type="month" className='form-control' placeholder='Year of Commencement of Business' id='year_of_commencement_text' name='year_of_commencement_text'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.year_of_commencement_text}
                                                    />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="year_of_commencement">Upload CIN Document<span style={{ color: "green", fontWeight: "100", fontSize: "13px" }}></span></label>
                                                    {
                                                        localStorage.getItem("company_details") ?
                                                            JSON.parse(localStorage.getItem("company_details")).year_of_commencement ?
                                                                <div>
                                                                    <div className="uploaded_gst" style={{ display: (!showNewYOCdiv ? "block" : "none") }}>
                                                                        <a href={"https://tapi.alobhatech.com/uploaded-files/" + JSON.parse(localStorage.getItem("company_details")).year_of_commencement} target='_blank'><button type='button' className='btn-sm mx-2'>Show Uploaded file</button></a>
                                                                        <button type='button' className='btn-sm mx-2' onClick={handleYOCfilediv}>Change</button>
                                                                    </div>
                                                                    <div className='change_gst_file' style={{ display: (showNewYOCdiv ? "block" : "none") }}>
                                                                        <input type="file" name='year_of_commencement_new' className='form-control'
                                                                            onChange={(e) => formik.setFieldValue("year_of_commencement_new", e.target.files[0])}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <input type="file" className='form-control' placeholder='Company GST Number' id='year_of_commencement' name='year_of_commencement'
                                                                    onChange={(e) => formik.setFieldValue("year_of_commencement", e.target.files[0])}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            :
                                                            <input type="file" className='form-control' placeholder='Company GST Number' id='year_of_commencement' name='year_of_commencement'
                                                                onChange={(e) => formik.setFieldValue("year_of_commencement", e.target.files[0])}
                                                                onBlur={formik.handleBlur}
                                                            />

                                                    }
                                                    {/* <input type="file" className='form-control' placeholder='Year of Commencement of Business' id='year_of_commencement' name='year_of_commencement'
                                                        onChange={(e) => formik.setFieldValue("year_of_commencement", e.target.files[0])}
                                                        onBlur={formik.handleBlur}
                                                    /> */}
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="gst_no_text">Company GST Number</label>
                                                    <input type="text" className='form-control' placeholder='Company GST Number' id='gst_no_text' name='gst_no_text'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.gst_no_text}
                                                    />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="gst_no">Upload GST Document</label>

                                                    {
                                                        localStorage.getItem("company_details") ?
                                                            JSON.parse(localStorage.getItem("company_details")).gst_no ?
                                                                <div>
                                                                    <div className="uploaded_gst" style={{ display: (!showNewGSTdiv ? "block" : "none") }}>
                                                                        <a href={"https://tapi.alobhatech.com/uploaded-files/" + JSON.parse(localStorage.getItem("company_details")).gst_no} target='_blank'><button type='button' className='btn-sm mx-2'>Show Uploaded file</button></a>
                                                                        <button type='button' className='btn-sm mx-2' onClick={handleGSTfilediv}>Change</button>
                                                                    </div>
                                                                    <div className='change_gst_file' style={{ display: (showNewGSTdiv ? "block" : "none") }}>
                                                                        <input type="file" name='gst_no_new' className='form-control'
                                                                            onChange={(e) => formik.setFieldValue("gst_no_new", e.target.files[0])}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <input type="file" className='form-control' placeholder='Company GST Number' id='gst_no' name='gst_no'
                                                                    onChange={(e) => formik.setFieldValue("gst_no", e.target.files[0])}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            :
                                                            <input type="file" className='form-control' placeholder='Company GST Number' id='gst_no' name='gst_no'
                                                                onChange={(e) => formik.setFieldValue("gst_no", e.target.files[0])}
                                                                onBlur={formik.handleBlur}
                                                            />

                                                    }
                                                    {/* <input type="file" className='form-control' placeholder='Company GST Number' id='gst_no' name='gst_no'
                                                        onChange={(e) => formik.setFieldValue("gst_no", e.target.files[0])}
                                                        onBlur={formik.handleBlur}
                                                    /> */}
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="pan_no_text">Company PAN Number</label>
                                                    <input type="text" className='form-control' placeholder='Company PAN Number' id='pan_no_text' name='pan_no_text'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.pan_no_text}
                                                    />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="pan_no">Upload PAN Document</label>
                                                    {
                                                        localStorage.getItem("company_details") ?
                                                            JSON.parse(localStorage.getItem("company_details")).pan_no ?
                                                                <div>
                                                                    <div className="uploaded_pan" style={{ display: (!showNewPANdiv ? "block" : "none") }}>
                                                                        <a href={"https://tapi.alobhatech.com/uploaded-files/" + JSON.parse(localStorage.getItem("company_details")).pan_no} target='_blank'><button type='button' className='btn-sm mx-2'>Show Uploaded file</button></a>
                                                                        <button type='button' className='btn-sm mx-2' onClick={handlePANfilediv}>Change</button>
                                                                    </div>
                                                                    <div className='change_pan_file' style={{ display: (showNewPANdiv ? "block" : "none") }}>
                                                                        <input type="file" name='pan_no_new' className='form-control'
                                                                            onChange={(e) => formik.setFieldValue("pan_no_new", e.target.files[0])}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <input type="file" className='form-control' placeholder='Company PAN Number' id='pan_no' name='pan_no'
                                                                    onChange={(e) => formik.setFieldValue("pan_no", e.target.files[0])}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            :
                                                            <input type="file" className='form-control' placeholder='Company PAN Number' id='pan_no' name='pan_no'
                                                                onChange={(e) => formik.setFieldValue("pan_no", e.target.files[0])}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                    }
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Number of Technical Manpower<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Number of Technical Manpower' id='no_of_manpower' name='no_of_manpower'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.no_of_manpower} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Type of the Organization<span></span></label>
                                                    {/* <input type="text" className='form-control' placeholder='Type of the Organization' id='type_of_organisation' name='type_of_organisation'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.type_of_organisation} /> */}
                                                    <select className='form-control form-select' id='type_of_organisation' name='type_of_organisation'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        defaultValue={formik.values.type_of_organisation}
                                                        value={formik.values.type_of_organisation}>
                                                        <option value="">-Select an option-</option>
                                                        <option value="Pvt. Ltd.">Pvt. Ltd.</option>
                                                        <option value="Ltd.">Ltd.</option>
                                                        <option value="Partnership">Partnership</option>
                                                        <option value="Proprietorship">Proprietorship</option>
                                                        <option value="LLP">LLP</option>
                                                        <option value="Any Other">Any Other</option>
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="last_year_turnover">Last Year Turnover<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Last Year Turnover' id='last_year_turnover' name='last_year_turnover'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.last_year_turnover} />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="company_main_services">Company Main Services(Upload Company Portfolio)</label>
                                                    {
                                                        localStorage.getItem("company_details") ?
                                                            JSON.parse(localStorage.getItem("company_details")).company_main_services ?
                                                                <div>
                                                                    <div className="uploaded_pan" style={{ display: (!showNewCMSdiv ? "block" : "none") }}>
                                                                        <a href={"https://tapi.alobhatech.com/uploaded-files/" + JSON.parse(localStorage.getItem("company_details")).company_main_services} target='_blank'><button type='button' className='btn-sm mx-2'>Show Uploaded file</button></a>
                                                                        <button type='button' className='btn-sm mx-2' onClick={handleCMSfilediv}>Change</button>
                                                                    </div>
                                                                    <div className='change_pan_file' style={{ display: (showNewCMSdiv ? "block" : "none") }}>
                                                                        <input type="file" name='company_main_services_new' className='form-control'
                                                                            onChange={(e) => formik.setFieldValue("company_main_services_new", e.target.files[0])}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <input type="file" className='form-control' placeholder='Company Main Services' id='company_main_services' name='company_main_services'
                                                                    onChange={(e) => formik.setFieldValue("company_main_services", e.target.files[0])}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            :
                                                            <input type="file" className='form-control' placeholder='Company Main Services' id='company_main_services' name='company_main_services'
                                                                onChange={(e) => formik.setFieldValue("company_main_services", e.target.files[0])}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                    }

                                                    {/* <input type="file" className='form-control' placeholder='Company Main Services' name='company_main_services' id='company_main_services'
                                                        onChange={(e) => formik.setFieldValue("company_main_services", e.target.files[0])}
                                                        onBlur={formik.handleBlur}
                                                    // value={formik.values.company_main_services}
                                                    /> */}
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="five_major_clients_text">5 Major Clients of the Organization</label>
                                                    <input type="text" className='form-control' placeholder='5 Major Clients of the Organization' name='five_major_clients_text' id='five_major_clients_text'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.five_major_clients_text}
                                                    />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="five_major_clients">Upload Relevant Documents</label>
                                                    {
                                                        localStorage.getItem("company_details") ?
                                                            JSON.parse(localStorage.getItem("company_details")).five_major_clients ?
                                                                <div>
                                                                    <div className="uploaded_pan" style={{ display: (!showNewFMCdiv ? "block" : "none") }}>
                                                                        <a href={"https://tapi.alobhatech.com/uploaded-files/" + JSON.parse(localStorage.getItem("company_details")).five_major_clients} target='_blank'><button type='button' className='btn-sm mx-2'>Show Uploaded file</button></a>
                                                                        <button type='button' className='btn-sm mx-2' onClick={handleFMCfilediv}>Change</button>
                                                                    </div>
                                                                    <div className='change_pan_file' style={{ display: (showNewFMCdiv ? "block" : "none") }}>
                                                                        <input type="file" name='five_major_clients_new' className='form-control'
                                                                            onChange={(e) => formik.setFieldValue("five_major_clients_new", e.target.files[0])}
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                :
                                                                <input type="file" className='form-control' placeholder='Five Major Clients' id='five_major_clients' name='five_major_clients'
                                                                    onChange={(e) => formik.setFieldValue("five_major_clients", e.target.files[0])}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            :
                                                            <input type="file" className='form-control' placeholder='Five Major Clients' id='five_major_clients' name='five_major_clients'
                                                                onChange={(e) => formik.setFieldValue("five_major_clients", e.target.files[0])}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                    }
                                                    {/* <input type="file" className='form-control' placeholder='5 Major Clients of the Organization' name='five_major_clients' id='five_major_clients'
                                                        onChange={(e) => formik.setFieldValue("five_major_clients", e.target.files[0])}
                                                        onBlur={formik.handleBlur}
                                                    // value={formik.values.five_major_clients} 
                                                    /> */}
                                                </div>

                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Proprietor/Partners/Directors/CEO<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Proprietor / Partners / Directors / CEO' name='name_of_proprietor' id='name_of_proprietor'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.name_of_proprietor}
                                                    />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Designation<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Designation' name='proprietor_designation' id='proprietor_designation'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.proprietor_designation}
                                                    />
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Mobile Number<span></span></label>
                                                    <input type="text" className='form-control' placeholder='Mobile Number' name='proprietor_mobile_no' id='proprietor_mobile_no'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.proprietor_mobile_no}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.proprietor_mobile_no && formik.errors.proprietor_mobile_no ? (
                                                            <div className='text-danger'>*{formik.errors.proprietor_mobile_no}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">E-Mail Address<span></span></label>
                                                    <input type="text" className='form-control' placeholder='E-Mail Address' name='proprietor_email' id='proprietor_email'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.proprietor_email}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.proprietor_email && formik.errors.proprietor_email ? (
                                                            <div className='text-danger'>*{formik.errors.proprietor_email}</div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                            </div>
                                            <input type="submit" name="next" className="next action-button" value="Save and Continue &rarr;" />
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
            <ToastContainer />
        </>
    )
}

export default ITServiceProviderCompanyDetails